import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "GlobalCarListFilter" })
export default class GlobalCarListFilter extends Vue {
    public localizer: any = Localizer;
    public productTypes: string = null;
    public selectedProductTypes: string = null;
    public selectedProductTypesLabel: string = null;

    public isDisc: boolean = false;
    public isPad: boolean = false;
    public isKit: boolean = false;
    public isPadAccessory: boolean = false;
    public isDrum: boolean = false;
    public isBrakeshoe: boolean = false;
    public isBrakeshoeKit: boolean = false;
    public isCaliper: boolean = false;
    public isLCVCaliper: boolean = false;
    public isBracket: boolean = false;
    public isHydraulic: boolean = false;
    public isUpgrade: boolean = false;
    public isUpgradeDisc: boolean = false;
    public isUpgradePad: boolean = false;
    public isUpgradeKit: boolean = false;

    public aftermarketList: any[] = [];
    public upgradeList: any[] = [];
    public isSelectingAllAftermarket: boolean = true;
    public isSelectingAllUpgrade: boolean = true;

    public brandCode: string = null;
    public modelCode: string = null;
    public typeCode: string = null;

    @Prop() readonly filter: any;
    @Prop() readonly searchProductTypes: any;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        const self = this;
        this.brandCode = this.filter.brandCode;
        this.modelCode = this.filter.modelCode;
        this.typeCode = this.filter.typeCode;

        await this.getProductTypes();

        if (this.productTypes) {
            let productTypesList: string[] = this.productTypes.split(",").filter(function (e) {
                return self.searchProductTypes.map(x => x.value).indexOf(e) > -1;
            });

            this.aftermarketList = this.searchProductTypes.filter(x => x.additionalValues[0].value === 'Aftermarket').map(function (item) { return item['value']; }).filter(x => productTypesList.includes(x));
            this.upgradeList = this.searchProductTypes.filter(x => x.additionalValues[0].value === 'Upgrade').map(function (item) { return item['value']; }).filter(x => productTypesList.includes(x));

            if (productTypesList.includes("Disc")) {
                this.isDisc = true;
            }

            if (productTypesList.includes("Pad")) {
                this.isPad = true;
            }

            if (productTypesList.includes("Kit")) {
                this.isKit = true;
            }

            if (productTypesList.includes("PadAccessory")) {
                this.isPadAccessory = true;
            }

            if (productTypesList.includes("Drum")) {
                this.isDrum = true;
            }

            if (productTypesList.includes("Brakeshoe")) {
                this.isBrakeshoe = true;
            }

            if (productTypesList.includes("BrakeshoeKit")) {
                this.isBrakeshoeKit = true;
            }

            if (productTypesList.includes("Caliper")) {
                this.isCaliper = true;
            }

            if (productTypesList.includes("Bracket")) {
                this.isBracket = true;
            }

            if (productTypesList.includes("Hydraulic")) {
                this.isHydraulic = true;
            }

            if (productTypesList.includes("UpgradeDisc")) {
                this.isUpgradeDisc = true;
                this.isUpgrade = true;
            }

            if (productTypesList.includes("UpgradePad")) {
                this.isUpgradePad = true;
                this.isUpgrade = true;
            }

            if (productTypesList.includes("UpgradeKit")) {
                this.isUpgradeKit = true;
                this.isUpgrade = true;
            }

            this.selectedProductTypes = productTypesList.filter(x => this.filter.productTypes?.includes(x)).toString();

            this.isSelectingAllAftermarket = this.aftermarketList.every(item => productTypesList.filter(x => this.filter.productTypes?.includes(x)).includes(item)) ? false : true;
            this.isSelectingAllUpgrade = this.upgradeList.every(item => productTypesList.filter(x => this.filter.productTypes?.includes(x)).includes(item)) ? false : true;

            this.setProductTypeLabel();
        }
    }

    public async getProductTypes() {
        const response = (await Axios.post(this.routes.CatalogueGlobalCarList_GetProductListTypes, { brandCode: this.brandCode, modelCode: this.modelCode, typeCode: this.typeCode })).data;
        this.productTypes = response;
    }

    public setProductTypes(productType: string) {
        let selectedProductTypesList: string[] = this.selectedProductTypes ? this.selectedProductTypes.split(",") : [];

        if (productType && productType !== "") {
            if (productType === "AddAftermarket") {
                selectedProductTypesList = selectedProductTypesList.concat(this.aftermarketList);
                selectedProductTypesList = [...new Set(selectedProductTypesList)];
            } else if (productType === "AddUpgrade") {
                selectedProductTypesList = selectedProductTypesList.concat(this.upgradeList);
                selectedProductTypesList = [...new Set(selectedProductTypesList)];
            } else if (productType === "LessAftermarket") {
                selectedProductTypesList = selectedProductTypesList.filter(x => !this.aftermarketList.includes(x));
            } else if (productType === "LessUpgrade") {
                selectedProductTypesList = selectedProductTypesList.filter(x => !this.upgradeList.includes(x));
            }

            if (!selectedProductTypesList.includes(productType) && productType !== "AddAftermarket" && productType !== "AddUpgrade" && productType !== "LessAftermarket" && productType !== "LessUpgrade") {
                selectedProductTypesList.push(productType);
            } else {
                selectedProductTypesList = selectedProductTypesList.filter(i => i !== productType);
            }

            this.selectedProductTypes = selectedProductTypesList.join(",");
        } else {
            this.selectedProductTypes = null;
        }

        this.productListFilterSubmit();
    }

    public async productListFilterSubmit() {
        const response = (await Axios.post(this.routes.CatalogueGlobalCarList_ProductListFilter, { brandCode: this.brandCode, modelCode: this.modelCode, typeCode: this.typeCode, productTypes: this.selectedProductTypes })).data;
        window.location.href = response.url;
    }

    public getDataValue(productType: string) {
        let dataTypeValue: boolean = false;

        if (productType) {
            if (!this.selectedProductTypes) {
                dataTypeValue = true
            } else {
                let selectedProductTypesList = this.selectedProductTypes.split(",");

                if (selectedProductTypesList.indexOf(productType) === -1) {
                    dataTypeValue = true;
                }
            }
        } else {
            if (this.selectedProductTypes && this.selectedProductTypes !== "") {
                dataTypeValue = true;
            }
        }

        return dataTypeValue;
    }

    public setProductTypeLabel() {
        let productTypesList: string[] = this.productTypes.split(",");
        var productTypesListFilter = this.searchProductTypes.filter(x => productTypesList.filter(x => this.filter.productTypes?.includes(x)).includes(x.value)).map(x => x.title);

        if (productTypesList.length > 0) {
            this.selectedProductTypesLabel = productTypesListFilter.slice(0, 3).join(', ');

            if (productTypesListFilter.length > 3) {
                this.selectedProductTypesLabel += " +" + (productTypesListFilter.length - 3);
            }
        } else {
            this.selectedProductTypesLabel = null;
        }
    }
}